import React from "react";
import { Link } from "react-router-dom";

function CategoryItem({ category }) {
  return (
    <Link to={`/show-books/${category.label}`} className="link">
      <div className="books-category-item">
        <div className="books-category-item-image-container">
          <img
            src={category && category.photo.url}
            alt="category"
            className="books-category-item-image"
          />
        </div>
        <h3 className="books-category-label">{category.label}</h3>
      </div>
    </Link>
  );
}

export default CategoryItem;
